import React from 'react'
import TrackTimeRemChatSection from './TrackTimeRemChatSection'
import ChatSection from './ChatSection'

export default function ChatModelWrapper({history}) {
  return (
    <div>
        <TrackTimeRemChatSection history={history}/>
        <ChatSection/>
    </div>
  )
}
